

























import Vue from 'vue'

const MINIMUM_NUMER_OF_PLACES_TO_DISPLAY_ICON_WITH_NUMBER = 5
const FETCH_NUMBER_OF_PLACES_REQUEST_URL_BASIS = `${location.origin}/watchout/api/places/count`
const FETCH_AVAILABLE_LANGUAGES_REQUEST_URL_BASIS = `${location.origin}/watchout/api/languages`

export default Vue.extend({
  data () {
    return {
      numberOfPlaces: undefined as undefined | number,
      minimumNumerOfPlacesToDisplayIconWithNumber: MINIMUM_NUMER_OF_PLACES_TO_DISPLAY_ICON_WITH_NUMBER,
      availableLanguages: [],
    }
  },
  created () {
    fetch(FETCH_NUMBER_OF_PLACES_REQUEST_URL_BASIS).then(response => response.json())
      .then(data => this.numberOfPlaces = data['place_count']);
    fetch(FETCH_AVAILABLE_LANGUAGES_REQUEST_URL_BASIS).then(response => response.json())
      .then(data => {this.availableLanguages = data;});
  }
})
